import angular from 'angular';
import uiRouter from 'angular-ui-router';
import pageNavigationComponent from './page-navigation.component';

let pageNavigationModule = angular.module('page-navigation', [
  uiRouter
])

.component('pageNavigation', pageNavigationComponent)

.name;

export default pageNavigationModule;



// WEBPACK FOOTER //
// ./client/app/common/page-navigation/page-navigation.js